var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('PushNotificationForm')],1),_c('div',{staticClass:"col-sm-6"},[_c('PushNotificationPreview')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }